import React from "react";
import EMICalculator from "@/components/tools/EMICalculator";

export default function EMICalcPage() {
  return (
    <main data-testid="emi-page" className="pt-24 md:pt-32 pb-24">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="chapter-index text-emerald-700">Tools · EMI Calculator</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-3 max-w-3xl">Every rupee, <span className="italic text-emerald-800">visualised.</span></h1>
        <p className="mt-6 text-slate-600 max-w-xl">Slide, adjust and see your EMI, interest outgo and total payable update in real time. No sign-up, no cookies.</p>
        <div className="mt-12 rounded-3xl bg-white border border-black/[0.06] p-8 md:p-12">
          <EMICalculator />
        </div>
      </section>
    </main>
  );
}
